export enum ClientType {
  Web = 'web',
  iOS = 'ios',
  Android = 'android',
}
